import type { NavigationGuard, RouteRecordRaw } from 'vue-router'

import { keys } from '@/app/i18n'
import { ROUTE_NOT_AUTHORIZED } from '@/app/router/names'
import { useAuthStore } from '@/app/stores/auth'

/**
 * The Notes page (2026-10-31, canvas "Skileo Notes"): a page of its own, no legacy path. Every Client and Staff user
 * opens it (no permission of its own: each note's "Who can see" decides, on the API); Freelancers have no notes (the
 * API answers them 403). `?note=<id>` opens that note in the drawer.
 */
const noFreelancer: NavigationGuard = () =>
  useAuthStore().userType === 'Freelancer' ? { name: ROUTE_NOT_AUTHORIZED } : true

const routes: RouteRecordRaw[] = [
  {
    path: '/:software/notes',
    name: 'notes',
    component: () => import('./views/NotesView.vue'),
    beforeEnter: noFreelancer,
    meta: {
      // the editor's toolbar and the tag field are shared strings; the people picker's groups are this module's
      software: 'common',
      pageTitle: keys.t('common.nav.notes'),
      breadcrumb: [{ text: keys.t('common.nav.notes'), active: true }],
    },
  },
]

export default routes
